// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__28xGP","logo":"header_logo__iXBMJ","nav":"header_nav__2vLlR","actions":"header_actions__3k-8K"};